import { Alert } from 'antd';

interface ReceiptNoticesProps {
  /** Why this trip cannot be received at all (aborted, closed out another way). */
  refusal: string | null;
  /** What is missing right now, as typed. */
  blockers: string[];
  /** Worth a look, not a block. */
  warnings: string[];
  /** The server's answer to the last Receive. */
  submitError: string | null;
}

/** Everything the supervisor should read before pressing Receive, each in the words the server uses. */
export function ReceiptNotices({ refusal, blockers, warnings, submitError }: ReceiptNoticesProps) {
  return (
    <>
      {refusal && <Alert type="error" showIcon title="This truck cannot be received" description={refusal} />}
      {blockers.length > 0 && (
        <Alert
          type="warning"
          showIcon
          title="Not ready to receive"
          description={
            <ul className="list-disc pl-4">
              {blockers.map((blocker) => (
                <li key={blocker}>{blocker}</li>
              ))}
            </ul>
          }
        />
      )}
      {warnings.map((warning) => (
        <Alert key={warning} type="info" showIcon title={warning} />
      ))}
      {submitError && <Alert type="error" showIcon title="The truck was not received" description={submitError} />}
    </>
  );
}
